import React from "react";
import LandingCategory from "../components/common/LandingCategory";
import { themes } from "../themes/themes";
import avatarMasculino from "../assets/images/moda.png";
import useTrackPageView from "../hooks/useTrackPageView";
import useTimeOnPage from "../hooks/useTimeOnPage";
import { trackEvent } from "../lib/analytics";

export default function Masculino() {
  useTrackPageView();
  useTimeOnPage();

  const handleWhatsappClick = async () => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "leads",
      category: "whatsapp",
      action: "click",
      label: "geral_cta_main",
    });

    await trackEvent("whatsapp_click", {
      buttonLocation: "masculino_cta_main",
    });

    // Certifique-se de que este link abaixo está correto e ativo
    window.open("https://midiapromo.com/zap/promosclubedohomem", "_blank");
  };

  return (
    <LandingCategory
      avatar={avatarMasculino}
      titleTop="CHEGA DE PAGAR"
      titleBottom="CARO EM ROUPAS!"
      highlightWord="EM ROUPAS!"
      members="40.000"
      description="Receba as melhores promoções de tênis ORIGINAIS todos os dias! 👟🔥"
      whatsappLink="https://midiapromo.com/zap/promosclubedohomem" // Certifique-se de que este link está correto
      telegramLink="https://t.me/seu-link"
      theme={themes.masculino}
      onWhatsappClick={handleWhatsappClick}
    />
  );
}